const initialAppState = true

export const changeDragable=(state = initialAppState, action)=>{
    switch (action.type) {
        case "turnOnDrag":
            return state=true
        case "turnOffDrag":
            return state=false
        default: return state
    }
}